import { ContinueSubscriptionDefinition } from "@super-real/types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const continueSubscriptionCallable = getCallable(
  ContinueSubscriptionDefinition
);
